import gql from 'graphql-tag';

export const ADD_USER_MESSAGE = gql`
  mutation
    addUserMessage(
      $name: String!
      $subject: String!
      $email: String!
      $lang: String!
      $message: String!
    ) {
      addUserMessage(name: $name, subject: $subject, email: $email, lang: $lang, message: $message) {
        userMessage {
            date
          }
      }
    }
  
`;
